import MetricCard from './MetricCard';

export default MetricCard;
